<template>
	<div class="character henry">
		<div class="bg-cork"></div>
		<div class="strings"></div>
		<div class="post-mark"></div>
		<router-link @click="toTop" to="/" class="desktop-keys">
			<div class="keys"></div>
		</router-link>
		<cc />
		<div class="vertical-string">
			<div class="media-wrapper">
				<div class="ch-photo"></div>

				<div class="player-wrapper" :class="{ 'disabled': audioUrl.length === 0 }">
					<AudioPlayer id="player1" :file="audioUrl" class="player"></AudioPlayer>
					<div class="label"><span>{{ lang('listen') }}</span></div>
				</div>

				<VDropdown :distance="-20" strategy="fixed" @show="popperShowHandler" @apply-show="popperApplyShow('read-more')" @hide="popperHideHandler">
					<!-- This will be the popover target (for the events and position) -->
					<div class="read-icon-wrapper"
						:class="{ 'disabled': readMore.length === 0, 'animate': readMore.length > 0 }">
						<div class="read-icon-1"></div>
						<div class="read-icon-2"></div>
						<div class="read-icon-3"></div>
						<div class="label"><span>{{ lang('read') }}</span></div>
					</div>
					<!-- This will be the content of the popover -->

					<template #popper>
						<div class="read-popper">
							<a class="popper-closer" v-close-popper><i class="fas fa-times-circle"></i></a>
							<ReadMore :popper-open="vPopperOpen" />
						</div>
					</template>
				</VDropdown>

				<VDropdown :distance="-20" strategy="fixed" @show="popperShowHandler" @apply-show="popperApplyShow('evidence')" @hide="popperHideHandler">
					<div class="evidence-icon"
						:class="{ 'empty-evidence': $evidence.value === null, 'animate': $evidence.value !== null }">
						<div class="label"><span>{{ lang('evidence') }}</span></div>
					</div>

					<!-- This will be the content of the popover -->
					<template #popper>
						<div class="evidence-popper">
							<a class="popper-closer" v-close-popper><i class="fas fa-times-circle"></i></a>
							<HenryEvidence />
						</div>
					</template>
				</VDropdown>
			</div>
		</div>

		<!-- CONTENT SCROLL -->
		<div class="character-d" scroll="no">
			<div class="slides">
				<TopTextBox :items="textBoxData" />

				<!-- composition -->
				<div class="composition zoom">
					<slide1 />
					<slide2 />
					<slideroot3 />
					<slidecrown4 />
					<slide5 />
					<slide6 />
					<slide7 />
					<slide8 />
					<slide9 />
					<slide10 />
					<slide11 />
					<slidenote12 />
					<slidenote13 />
					<slidenote14 />
					<slidenote15 />
					<slidenote16 />
					<slidenote17 />
					<slidesheet18 />
					<slidemagazin19 />
					<slidemagazin20 />
					<slidesticker21 />
					<slidehand22 />
					<slidesticker23 />
					<slidehand24 />
					<slidepickets25 />
					<slidesticky26 />
					<slidecrown27 />
					<slidefinish28 />
				</div>
				<!-- // composition -->
			</div>

			<ControlsButton class="henry-controls-button" :data="controlsButtonData" />
			<cc-control></cc-control>
			<langControl/>
			<black_overlay id="black_overlay" :overlay="overlay" />
			<outro id="outro" :outro="outro" />
		</div>
		<!-- // CONTENT SCROLL -->
	</div>
</template>

<script>
import AudioPlayer from '../../components/audioPlayer.vue';
import ControlsButton from '../../components/controlsButton';
import controlsButtonData from './henry/controlsButtonData';
import TopTextBox from '../components/TopTextBox';
import textBoxData from './henry/text-box';
import ReadMore from '../components/ReadMore.vue';
import evidence from '../components/evidence.vue';
import outro from './outro.vue';
import black_overlay from './black_overlay.vue';

import slide1 from './henry/slide-1';
import slide2 from './henry/slide-2';
import slideroot3 from './henry/slideroot-3';
import slidecrown4 from './henry/slidecrown-4';
import slide5 from './henry/slide-5';
import slide6 from './henry/slide-6';
import slide7 from './henry/slide-7';
import slide8 from './henry/slide-8';
import slide9 from './henry/slide-9';
import slide10 from './henry/slide-10';
import slide11 from './henry/slide-11';
import slidenote12 from './henry/slidenote-12';
import slidenote13 from './henry/slidenote-13';
import slidenote14 from './henry/slidenote-14';
import slidenote15 from './henry/slidenote-15';
import slidenote16 from './henry/slidenote-16';
import slidenote17 from './henry/slidenote-17';
import slidesheet18 from './henry/slidesheet-18';
import slidemagazin19 from './henry/slidemagazin-19';
import slidemagazin20 from './henry/slidemagazin-20';
import slidesticker21 from './henry/slidesticker-21';
import slidehand22 from './henry/slidehand-22';
import slidesticker23 from './henry/slidesticker-23';
import slidehand24 from './henry/slidehand-24';
import slidepickets25 from './henry/slidepickets-25';
import slidesticky26 from './henry/slidesticky-26.vue';
import slidecrown27 from './henry/slidecrown-27.vue';
import slidefinish28 from './henry/slidefinish-28.vue';
import cc from '../../components/cc.vue'
import cc_control from '../../components/cc_control.vue'
import langControl from '../../components/langControl.vue'

export default {
	name: 'henry',
	inject: ['helpers', 'lang'],
	components: {
		ControlsButton,
		TopTextBox,
		AudioPlayer,
		ReadMore,
		'HenryEvidence': evidence,
		outro,
		black_overlay,
		cc,
		'cc-control': cc_control,
		langControl,

		slide1,
		slide2,
		slideroot3,
		slidecrown4,
		slide5,
		slide6,
		slide7,
		slide8,
		slide9,
		slide10,
		slide11,
		slidenote12,
		slidenote13,
		slidenote14,
		slidenote15,
		slidenote16,
		slidenote17,
		slidesheet18,
		slidemagazin19,
		slidemagazin20,
		slidesticker21,
		slidehand22,
		slidesticker23,
		slidehand24,
		slidepickets25,
		slidesticky26,
		slidecrown27,
		slidefinish28
	},
	data() {
		return {
			controlsButtonData,
			textBoxData,
			showModal: false,
			audioUrl: '',
			vPopperOpen: false,
			popperType: '',
			readMore: '',

			outro: [
				{
					start: 28900,
					end: 29700,
					fromStyle: { bottom: '-250%', opacity: 0.8 },
					toStyle: { bottom: '0%', opacity: 1 }
				}
			],

			overlay: [
				{
					start: 28900,
					end: 29700,
					fromStyle: { opacity: '0' },
					toStyle: { opacity: '0.9' },
					easing: 'linear'
				}
			]
		}
	},
	created() {
		this.$watch('$audioUrl.value', (newVal) => {
			this.setAudioUrl(newVal);
		}, { immediate: true });

		this.$watch('$readMore.value', (newVal) => {
			this.setReadMore(newVal);
		}, { immediate: true });
	},
	mounted() {
		window.document.querySelector('html').scrollTo({
			top: 0,
			behavior: "instant"
		});
		setTimeout(() => {
			this.helpers.enableScrolling();
		}, 1000);
	},
	methods: {
		setAudioUrl(value) {
			this.audioUrl = value;
		},
		setReadMore(value) {
			this.readMore = value;
		},
		popperApplyShow(type) {
			this.popperType = type
		},
		popperShowHandler() {
			setTimeout(() => {
				if(document.querySelector('.v-popper__popper--shown')) {
					document.querySelector('.v-popper__popper--shown').classList.add(this.popperType);
				}
			}, 500);
			this.vPopperOpen = true;
		},
		popperHideHandler() {
			const self = this;      // this.helpers.enableScrolling();
			setTimeout(() => {
				if(document.querySelector('.v-popper__popper--shown')) {
					document.querySelector('.v-popper__popper--shown').classList.remove('evidence');
					document.querySelector('.v-popper__popper--shown').classList.remove('read-more');
				}
				self.vPopperOpen = false;
			}, 500);
		},
		toTop() {
			window.scrollTo({
				top: 0,
				behavior: 'smooth'
			});
			this.helpers.enableScrolling();
		}

	},
}
</script>

<style lang="scss" scoped>
html {
	-ms-overflow-style: none;
	/* IE and Edge */
	scrollbar-width: none;

	/* Firefox */
	&::-webkit-scrollbar {
		display: none;
	}
}

img {
	max-width: 100%;
	width: auto;
}

.henry {
	.ch-photo {
		background-image: url('/themes/rise-theme/dist/images/estate/character-view/henry.png') !important;
		width: 300px !important;
		height: 250px !important;
		left: -6px !important;
		transform-origin: 135px 30px !important;
	}

	.post-mark {
		background-image: url('/themes/rise-theme/dist/images/estate/character-view/post-mark-2.png') !important;

		@media(max-width: 600px) {
			display: none;
		}

	}
}
.henry-controls-button {
	bottom: 59px;
}
.slides {
	position: fixed;
	left: 0;
	top: 0;
	width: 100%;
	height: 100%;
	z-index: 5;
}

.composition {
	position: absolute;
	top: calc(50% - 275px);
	left: calc(50% - 450px);
	max-width: 1150px;
	width: 100%;
}

.slide-note {
	max-width: 400px;
	position: absolute;
	top: 0;
	right: 0;
	z-index: 3;
	transform: translateX(40%) translateY(-150%);
	transition: all 0.3s linear;
}

.comment-box {
	opacity: 0;
}

@media screen and (max-width: 1680px) {
	.composition {
		max-width: 1000px;
		top: calc(50% - 270px);
		left: calc(50% - 395px);
	}
}

@media screen and (max-width: 1440px) {
	.composition {
		max-width: 879px;
		top: calc(50% - 221px);
		left: calc(50% - 356px);
	}
}

@media screen and (max-width: 1280px) {
	.composition {
		max-width: 600px;
		top: calc(50% - 174px);
		left: calc(50% - 243px);
	}

	.slide-note {
		max-width: 250px;
	}
}

@media screen and (max-width: 650px) {
	.henry .ch-photo {
		position: absolute;
		left: 50% !important;
		transform: translateX(-50%);
		bottom: 80vh;
		animation: none;
		height: 180px !important;
		width: 150px !important;
		background-size: 200px !important;
	}

	.composition {
		max-width: 300px;
		top: calc(50% - 70px);
		left: calc(50% - 150px);
	}

	.slide-note {
		max-width: 120px;
		right: 5%;
	}

	.comment-box br {
		display: none;
	}
}

@media screen and (max-width: 400px) {
	.henry .ch-photo {
		height: 90px !important;
		background-size: 120px !important;
	}

	.composition {
		top: calc(50% - 42px);
	}
}

@media screen and (max-width: 991px) and (orientation: landscape) {
	.character-d .zoom {
		zoom: 0.5 !important;
		top: calc(50% - 115px);
	}
	.character-d .slide-sticker {bottom: -20%;}
}
</style>
